import { AccessResponseViewModel } from 'bff';
import { atom } from 'jotai';

export const allowActingAsAllAtom = atom<boolean>(false);
export const isProxyAtom = atom<boolean>(false);
export const isLoadingGetAccessAtom = atom<boolean>(false);
export const proxyIntermediaryListAtom = atom<AccessResponseViewModel | undefined>(undefined);
